/**
 * One place that answers "are we in mobile view?".
 *
 * Mobile here means the point where the layout switches to its stacked form:
 * the navbar collapses into the hamburger, the filters panel becomes an
 * overlay drawer, and the builder workspace stacks. That is Bootstrap's `lg`
 * breakpoint, and the SCSS media queries use the same number — keep them in
 * step if either moves.
 */
export const MOBILE_QUERY = "(max-width: 991.98px)";

export const isMobileView = (): boolean =>
  typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches;

/** The Bootstrap collapse shared by AuthHeader and BuilderHeader. */
const NAV_COLLAPSE_ID = "authHeader";

/**
 * Closes the mobile navbar after a dashboard is picked — otherwise the menu
 * stays open on top of the page the user just asked for.
 *
 * Bootstrap decides open/closed from the `show` class (`toggle()` checks
 * `_isShown()`), so removing it is all this needs and the hamburger still
 * works on the next press.
 */
export const closeMobileNav = (): void => {
  if (!isMobileView()) return;
  document.getElementById(NAV_COLLAPSE_ID)?.classList.remove("show");
};
